import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { WebPopService } from '../services';
import { State } from '../services/work.state';

export const closeScript = (webPop: WebPopService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.closeScript !== undefined) {
        webPop.closeInternal();
        const newState = {
          ...state,
          ...{
            closeScript: state.system?.closeScript,
            system: {
              ...state.system,
              ...{
                closeScript: undefined,
              },
            },
          },
        };
        return of([newState, currentState] as [Partial<State>, State]);
      }

      return of([state, currentState] as [Partial<State>, State]);
    })
  );
